import VueRouter from 'vue-router'
// router setup
import routes from './routes'

// configure router
export default new VueRouter({
  mode: 'hash',
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})
